<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>地址管理</span>
      </div>
      
      <!-- 搜索区域 -->
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="用户手机号">
          <el-input v-model="queryParams.userPhone" placeholder="请输入手机号" clearable />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="queryParams.contactName" placeholder="请输入联系人" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table v-loading="loading" :data="addressList">
        <el-table-column label="地址ID" align="center" prop="id" width="80" />
        <el-table-column label="用户信息" align="center" prop="userName" width="120" />
        <el-table-column label="联系人" align="center" prop="contactName" width="100" />
        <el-table-column label="联系电话" align="center" prop="contactPhone" width="120" />
        <el-table-column label="详细地址" align="center" prop="detailAddress" show-overflow-tooltip />
        <el-table-column label="默认地址" align="center" prop="isDefault" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isDefault === 1 ? 'success' : 'info'">
              {{ scope.row.isDefault === 1 ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" width="180" />
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AddressManage',
  data() {
    return {
      loading: true,
      total: 0,
      addressList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userPhone: undefined,
        contactName: undefined
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      // TODO: 调用API获取地址列表
      setTimeout(() => {
        this.addressList = []
        this.total = 0
        this.loading = false
      }, 500)
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleDelete(row) {
      this.$confirm('是否确认删除该地址?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('删除成功')
        this.getList()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>
